import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HTTP_STATUS} from '../common/api-helpers';
import {AuthService} from '../components/auth/auth.service';
import {UserRole} from '../enums/user-role';
import {AppConfigService} from './config.service';

@Injectable()
export class SettingsApiService {

    private settingsApiPathMap: {[userRole in UserRole]: string} = {
        [UserRole.ADMIN]:        this.appConfigService.api['backofficeSettings'],
        [UserRole.TRADER]:       this.appConfigService.api['settings'],
        [UserRole.TRADER_ADMIN]: this.appConfigService.api['settings']
    };

    constructor(
        protected appConfigService: AppConfigService,
        protected httpClient: HttpClient,
        protected authService: AuthService
    ) {}

    public store<T>(key: string, value: T): Observable<any> {
        const url: string = `${this.getSettingsApiUrl()}/${key}`;

        return this.httpClient.post(url, value);
    }

    public fetch<T>(key: string): Observable<T> {
        const url: string = `${this.getSettingsApiUrl()}/${key}`;

        return this.httpClient.get<T>(url, {
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<T>) => response.body),
            catchError((response: HttpResponse<T>) => response.status === HTTP_STATUS.NOT_FOUND
                ? of(null)
                : throwError(response)
            )
        );
    }

    private getSettingsApiUrl(): string {
        return this.settingsApiPathMap[this.authService.userRole];
    }

}
